import VadImage from "vadimages-nextjs-image-optimizer";
import React from "react";

interface ISuggestedSproutSettingProps
{
    settingName: 'voltage' | 'activepulse' | 'wattage';
    boxName: string;
    imageDirectory: string;
}

const SuggestedSproutSetting = ({ settingName, boxName, imageDirectory }: ISuggestedSproutSettingProps) => {
    const settingNames = {
        'voltage': 'Voltage',
        'activepulse': 'ACTIVE Pulse™',
        'wattage': 'Wattage',
    };
    return <div className='flex flex-col items-center gap-5'>
        <h5 className='font-semibold'>{settingNames[settingName]}</h5>
        <VadImage
            src={`${imageDirectory}${boxName}-${settingName}.png`}
            alt={`${boxName} ${settingName}`}
            width={200}
            height={62}
        />
    </div>
}

export default SuggestedSproutSetting;
